import AuthorisedClinic from "./authorisedClinic.container";

export default AuthorisedClinic;
